import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { intraCuHandoverNrChartConfig } from '../chartConfigs';

/**
 * Props for the IntraCuHandoverNrEcharts component
 */
interface IntraCuHandoverNrEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * Intra CU Handover Success Rate Chart (NR Site Level)
 * 
 * Displays Intra-Centralized Unit (CU) handover metrics for NR sites:
 * - Intra CU Handover Success (count)
 * - Intra CU Handover Attempt (count)
 * - Intra CU Handover Success Rate (percentage)
 * 
 * @component
 * @example
 * ```tsx
 * <IntraCuHandoverNrEcharts onFullscreenToggle={handleFullscreen} isFullscreen={false} />
 * ```
 * 
 * @see {@link ../chartConfigs.ts} - Chart configuration (intraCuHandoverNrChartConfig)
 * @see {@link ../../../components/SiteCharts/SiteCharts.tsx} - Template component
 * @see API: /api/nr/intra-cu-handover?site_name={siteName}
 */
const IntraCuHandoverNrEcharts: React.FC<IntraCuHandoverNrEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={intraCuHandoverNrChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default IntraCuHandoverNrEcharts;
